import { API_LOAN_GET_CREDIT_DENIAL, API_LOAN_GET_CREDIT_DENIAL_BY_KEY } from 'config'
import Api from 'services/api'

export const getCreditDenial = () => {
  return Api.get(API_LOAN_GET_CREDIT_DENIAL)
}

export const updateCreditDenial = (key: string, value: any) => {
  return Api.put(API_LOAN_GET_CREDIT_DENIAL_BY_KEY, { value }, { key })
}

export const getCreditDenialLogs = (key: string) => {
  return Api.get(API_LOAN_GET_CREDIT_DENIAL_BY_KEY, { key }, { key: 'log' })
}
